export function buildPaginationParameters(maxPage: number, page: number): {totalPages: number, currentPage: number} {
    return {
        totalPages: maxPage > 0 ? maxPage : 1,
        currentPage: !page || typeof page !== "number" ? 1 : page
    };
}